import css from 'styled-jsx/css';
import { serif, sansSerif } from 'styles/css-constants';
import { sharedPalette } from 'styles/colors/constants';
import { uppercase } from 'styles/typography/css-mixins';

// Going to explicitly ignore browsers that don't support Grid for now
export default css`
  .TeaserRecipeCard__editInfo {
    padding: 10px 0 0;
  }

  .TeaserRecipeCard__editInfoToolbar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 1.5rem;
    width: 100%;
  }

  .TeaserRecipeCard__editInfoIconButton {
    display: flex;
    align-items: center;
    font-size: var(--fontScaleNeg1);
    font-weight: bold;
    ${uppercase}
    cursor: pointer;
    border-right: 1px solid #ccc;
    padding: 0 0.8rem;
  }

  .TeaserRecipeCard__editInfoIconButton:last-child {
    border-right: none;
    margin-right: 0;
  }

  .TeaserRecipeCard__editInfoIconButton__copy :global(.ActionIcon) {
    background: white;
    padding: 0;
    font-size: 1.2rem;
  }

  .TeaserRecipeCard__editInfoIconButton__copy :global(.ActionIcon .icon),
  .TeaserRecipeCard__editInfoIconButton__copy :global(.ActionIcon__label) {
    color: black;
  }

  .TeaserRecipeCard__editInfoIconButton__copy :global(.ActionIcon__label) {
    font-size: 0.8rem;
  }

  .TeaserRecipeCard__editInfoIconButton__share {
    font-size: 1.5rem;
  }

  .TeaserRecipeCard__editInfoIconButton__share :global(.ActionIcon--recipeBox) {
    color: transparent;
    padding: 0;
  }

  .TeaserRecipeCard__editInfoIconButton__share :global(.ActionIcon__content) {
    color: black;
  }

  .TeaserRecipeCard__editInfo h3 {
    font-family: ${serif};
    font-size: var(--baseFontScale);
    font-weight: bold;
    padding-left: 10px;
  }

  .TeaserRecipeCard__deleteRecipeFromBox {
    color: ${sharedPalette.watermelon};
    display: flex;
    ${uppercase}
    font-size: 0.8rem;
    justify-content: flex-end;
    margin: 1rem;
    align-items: flex-end;
    font-weight: bold;
    width: 90%;
  }

  .TeaserRecipeCard__deleteRecipeFromBox :global(svg) {
    width: 1rem;
    height: 1rem;
    margin-right: 0.35rem;
  }

  .TeaserRecipeCard__editInfoRating {
    margin: 1rem 0;
    padding-left: 10px;
    padding-right: 10px;
  }

  .TeaserRecipeCard__editInfoNotes {
    display: flex;
    flex-direction: column;
    padding: 0 10px;
  }

  .TeaserRecipeCard__editInfoNotes label {
    font-size: var(--fontScaleNeg1);
    font-weight: bold;
    text-transform: uppercase;
  }

  .TeaserRecipeCard__editInfoNotes textarea {
    width: 100%;
    font-family: ${serif};
    font-size: initial;
    padding: 0.25rem;
    resize: none;
  }

  .TeaserRecipeCard__editInfoNotes button {
    margin-top: 0.5rem;
    padding: 0.15rem;
    width: 90px;
    height: 30px;
    border: none;
    background: ${sharedPalette.kYellow};
    font-size: 11px;
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
  }

  .TeaserRecipeCard__editInfoButton {
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    background: #000;
    color: #fff;
    font-size: 1rem;
    padding: 15px;
    margin-top: 2rem;
    width: 100%;
    cursor: pointer;
  }

  .TeaserRecipeCard__editForm {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: #fff;
    background: rgba(255, 255, 255, 0.8);
    overflow-y: scroll;
  }

  .TeaserRecipeCard__editInfoRating :global(.RecipeRating__text) {
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg2);
    font-weight: bold;
    text-transform: none;
  }

  .TeaserRecipeCard__editInfoRating :global(.RecipeRating__rateNow) {
    font-size: var(--fontScaleNeg1);
  }
`;
